import './base/';

/*
 * Polyfills
 */
import './polyfills/object-fit';
import 'lazysizes';

/*
 * Utils
 */
import bodyLoaded from './utils/bodyLoaded';
import isMobile from './utils/isMobile';
import isMobileDevice from './utils/isMobileDevice';

/*
 * Modules
 */
import './modules/triggerProductButton';
import './modules/navClick';
import './modules/navClose';
import './modules/navTrigger';
import './modules/navBackground';
import './modules/initSliders';
// import './modules/appendWeglotToHeader';
import './modules/numberChange';
import './modules/hideHeaderBanner';
import './modules/append-btn-to-instagram-section';
import './modules/smoothScroll';
import './modules/wrapVideoIframe';
import './modules/nav-footer';
